<template>
  <!-- 招聘广场 - 发布招聘 -->
  <div class="releaseRecruitWrap">
    <div class="tipList">
      <span class="leftSpan">职位类型</span>
      <div class="divRight">
        <select placeholder="请选择职位类型" :class="jobType == 0 ? 'placeholder' : '' " v-model="jobType">
          <option value="0">请选择职位类型</option> 
          <option :value="item.code" v-for="item in jobTypeList">{{item.value}}</option>       
        </select>
      </div>      
    </div>
    <div class="line"></div>
    <div class="tipList">
      <span class="leftSpan">招聘职位</span>
      <div class="divRight">
        <input type="text" placeholder="请输入需要招聘的工作职位" v-model="advertisePosition" maxlength="20">
      </div>      
    </div>
    <div class="line"></div>
    <div class="tipList">
      <span class="leftSpan">薪资范围</span>
      <div class="divRight">
        <input class="start" type="number" pattern="[0-9]*" placeholder="最低" maxlength="5" v-model="minSalary">K
        <!-- <input class="start" type="num" @keyup="minSalary=minSalary.replace(/\D/g,'')" placeholder="最低" maxlength="5" v-model="minSalary">K -->
        至
        <input class="end" type="number" pattern="[0-9]*"   placeholder="最高" maxlength="5" v-model="maxSalary">K
        <!-- <input class="end" type="num" @keyup="maxSalary=maxSalary.replace(/\D/g,'')" placeholder="最高" maxlength="5" v-model="maxSalary">K -->
      </div>      
    </div>
    <div class="line"></div>
    <div class="tipList">
      <span class="leftSpan">所在区域</span>
      <div class="divRight">
        <input type="text" placeholder="请选择所在区域" @click="showregioncityareaFN" readonly v-model="regioncityarea" maxlength="20">
      </div>      
    </div>
    <div class="line"></div>
    <div class="tipList">
      <span class="leftSpan">工作地点</span>
      <div class="divRight">
        <input type="text" placeholder="请输入该职位员工的工作地点" v-model="workingPlace" maxlength="20">
      </div>      
    </div>
    <div class="line"></div>
    <div class="tipList">
      <span class="leftSpan">经验要求</span>
      <div class="divRight">
        <select placeholder="请选择职位类型" :class="experience == 0 ? 'placeholder' : '' " v-model="experience">
          <option value="0">是否要求员工有相关工作经验</option>       
          <option :value="item.code" v-for="item in experienceList">{{item.value}}</option> 
        </select>
      </div>      
    </div>
    <div class="line"></div>
    <div class="tipList">
      <span class="lineSpan">职位描述</span>
      <div class="divDown">
        <textarea placeholder="请输入公司对此职位的能力描述" v-model="positionExplain" maxlength="200"></textarea>
      </div>      
    </div>
    <div class="line"></div>
    <div class="tipList">
      <span class="lineSpan">职位要求</span>
      <div class="divDown">
        <textarea placeholder="请输入公司对此职位的任职要求" v-model="positionDemand" maxlength="200"></textarea>
      </div>      
    </div>
    <div class="sendDiv">
      <div class="submit" @click="sendData">提交</div>
    </div>
    <mt-popup v-model="popupVisible" position="bottom" :closeOnClickModal="false">
      <span class="closepopup" @click="popupVisibleFlase">关闭</span>
      <mt-picker :slots="slots" value-key="value" @change="onValuesChange"></mt-picker>
    </mt-popup>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import '../js/flexible.debug.js'
import global from "../js/global.js"
export default {
  data () {
    return {
      advertisePosition:'',//招聘职位
      jobType:0,//职位类型
      maxSalary:'',//止薪
      minSalary:'',//起薪
      experience:0,//经验要求
      positionDemand:'',//职位要求
      positionExplain:'',//职位描述
      workingPlace:'',//工作地点
      region:'',
      city:'',
      area:'',
      regioncityarea:'', // 显示省市区
      popupVisible:false, // 是否显示
      jobTypeList:[],
      experienceList:[],
      token:"",
      addcity:[],
      slots: [
        {
          flex: 1,
          values: [],
          className: 'slot1',
          textAlign: 'center'
          }, {
          flex: 1,
          values: [],
          className: 'slot2',
          textAlign: 'center'
          }, {
          flex: 1,
          values: [],
          className: 'slot3',
          textAlign: 'center'
        }
      ],
    }
  },
  created(){
  },
  mounted(){
    window.getToken = this.getToken;
    if(global.getmobiletype()=="android"){     
      this.token = control.getToken(); 
      this.init();
    }
    else{
        window.webkit.messageHandlers.getToken.postMessage({"mothedName":"getToken"});
    }
    this.$http.get("/system/get/all/province/to/area/unified/structure")
    .then((response) => {
        this.addcity=response.respData;
    });
  },
  methods:{
    getToken(token){
      this.token = token;
      this.init();
    },
    onValuesChange(picker, values) {
      //picker.setValues([this.addcity[0],address[0].childs[0],address[0].childs[0].childs[0]])
      if(!values[0]){
          return;
      }
      else{
          picker.setSlotValues(1, values[0].cityList);
          let town = [];
          if(values[1]){
              town = values[1].areaList;
          }
          picker.setSlotValues(2,town);
      }
      this.$nextTick(()=>{
          this.region=values[0].key;
          this.city=values[1]?values[1].key:'';
          this.area=values[2]?values[2].key:'';
          this.regioncityarea=(values[0]?values[0].value:'')+(values[1]?values[1].value:'')+(values[2]?values[2].value:'')
      })     
    },
    popupVisibleFlase(){
      this.popupVisible=false;
      document.body.addEventListener('touchmove', function (e) {
          e.returnValue = true;
      }, {passive: false});
    },
    showregioncityareaFN(){
      this.popupVisible=true;
      document.body.addEventListener('touchmove', function (e) {
          e.preventDefault(); //阻止默认的处理方式(阻止下拉滑动的效果)
      }, {passive: false});
      this.slots[0].values=this.addcity;
      this.slots[1].values=this.addcity[0].cityList;
      this.slots[2].values=this.addcity[0].cityList[0].areaList;
    },
    init(){
      this.$http.get("/system/get/all/province/to/area/unified/structure")
      .then((response) => {
          this.addcity=response.respData;
      });
      // this.$http.get("system/masterData/list?type=15",{headers:{"Authorization":"bearer 8e112ceeed8b70a494709cdaa228837c"}})
      this.$http.get("system/masterData/list?type=15",{headers:{"Authorization":"bearer "+this.token+""}})
			.then((response) => {
          this.jobTypeList = response.respData.resultData
      });
      // this.$http.get("system/masterData/list?type=18",{headers:{"Authorization":"bearer 8e112ceeed8b70a494709cdaa228837c"}})
      this.$http.get("system/masterData/list?type=18",{headers:{"Authorization":"bearer "+this.token+""}})
			.then((response) => {
          this.experienceList = response.respData.resultData
      });
    },
    sendData(){
      if(this.jobType == 0){
        this.$toast("请选择职位类型");
        return;
      }else if(this.advertisePosition == ""){
        this.$toast("请输入招聘职位");
        return;
      }else if(this.maxSalary == "" || this.minSalary == "" || (/\D/g.test(this.maxSalary)) ||  (/\D/g.test(this.minSalary))){
        this.$toast("请输入正确的薪资范围");
        return;
      }else if(this.workingPlace == ""){
        this.$toast("请输入工作地点");
        return;
      }else if(this.experience == 0){
        this.$toast("请选择经验要求");
        return;
      }else if(this.positionExplain == ""){
        this.$toast("请输入职位描述");
        return;
      }else if(this.positionDemand == ""){
        this.$toast("请输入职位要求");
        return;
      }else if(this.regioncityarea == ""){
        this.$toast("请选择省市区");
        return;
      }
      Indicator.open();
      var data = {
        'advertisePosition': this.advertisePosition,//招聘职位
        'jobType': this.jobType,//职位类型
        'maxSalary': this.maxSalary,//止薪
        'minSalary': this.minSalary,//起薪
        'experience': this.experience,//经验要求
        'positionDemand': this.positionDemand,//职位要求	
        'positionExplain': this.positionExplain,//职位描述	
        'workingPlace': this.workingPlace,//工作地点
        'region':this.region,
        'city':this.city,
        'area':this.area,
      }
      // this.$http.post("content/advertise/add"+global.buildParams(data),"",{headers:{"Authorization":"bearer f14fc216ed419ffca28f36125ca36fce"}})
      this.$http.post("content/advertise/add"+global.buildParams(data),"",{headers:{"Authorization":"bearer "+this.token+""}})
			.then((response) => {
          Indicator.close();
          //提交成功之后跳转页面
          if(global.getmobiletype()=="android"){
            control.refreshPageWithShare(
              global.ipHeader+"/workInfo?contentId="+response.respData+"&accountId="+this.$route.query.accountId,
              "职位详情",
              response.respData,
              3
            )
          }
          else{
              window.webkit.messageHandlers.reloadRecruitTypeVCWithJobType.postMessage(this.jobType);
              window.webkit.messageHandlers.refreshNewWebView.postMessage(
                {
                  "url":global.ipHeader+"/workInfo?contentId="+response.respData+"&accountId="+this.$route.query.accountId,
                  "webTitle":"职位详情",
                  'contentId':response.respData,
                  'dataType':'3',
                  "mothedNameArr":["getToken","popViewToControllerWithLevelNum"]
                });
          }
			});
    }
  }
}
</script>

<style scoped lang="less">
.releaseRecruitWrap{
  background: #fbf6f6;
  padding-top: 32px;
  input::input-placeholder{color:#D1D1D1!important;} 
  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder { 
    color: #D1D1D1!important; 
  } 
  input:-moz-placeholder, textarea:-moz-placeholder { 
    color: #D1D1D1!important; 
  } 
  input::-moz-placeholder, textarea::-moz-placeholder { 
    color: #D1D1D1!important; 
  } 
  input:-ms-input-placeholder, textarea:-ms-input-placeholder { 
    color: #D1D1D1!important; 
  } 
  input,textarea,select{
    border: 0;
  }
  input:focus,textarea:focus,select:focus{
    outline:none
  }
  select::-ms-expand{display:none;}
  select{
    background-color: #fff;
    appearance:none;
    -moz-appearance:none;
    -webkit-appearance:none;
  }
  .placeholder{
    color: #D1D1D1;
  }
  .line{
    height: 20px;
    background: #fbf6f6;
  }
  .tipList{
    background: #fff;
    overflow: hidden;
    .leftSpan{
      float: left;
      display: inline-block;
      line-height: 88px;
      font-size: 28px;
      color: #333440;
      font-weight: bold;
      width: 174px;
      text-align: center;
      margin-right: 8px;
    }
    .divRight{
      float: left;
      height: 88px;
      width: 516px;
      input{
        width: 100%;
        padding: 24px 0;
        font-size: 28px;
      }      
      .start{
        width: 200px;
      }
      .end{
        width: 200px;
        text-align: center;
      }
      select{
        width: 100%;
        padding: 24px 0;
        font-size: 28px;
      }
    }
    .lineSpan{
      line-height: 88px;
      font-size: 28px;
      color: #333440;
      font-weight: bold;
      text-indent: 30px;
      width: 100%;
      display:block;
    }
    .divDown{
      height: 164px;
      padding: 0 30px;
      textarea{
        width: 100%;
        height: 100%;
        font-size: 28px;         
        resize: none;  
      }
    }
  }
  .sendDiv{
    width: 100%;
    height: 180px;
    background: #fbf6f6;
    padding: 40px 30px 60px 30px;
    .submit{
      background-image: linear-gradient(90deg, #EF4B4B 0%, #F7643C 100%);
      box-shadow: 4px 8px 20px 0 rgba(239,75,75,0.27);
      border-radius: 8px;
      line-height: 80px;
      color: #fff;
      font-size: 30px;
      text-align: center;
    }
  }
  .mint-popup-bottom{
      width: 100%;
    }
    .closepopup{
      float: right;
      font-size: 20px;
      margin-right:10px;
      margin-top: 10px;
      padding-bottom:20px;
      color: #EF4B4B;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/releaseRecruit.vue